// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"e85a0242","232":"77f1787d","475":"e505865f","884":"750461f7","956":"bfdfab1c"}[chunkId] + ".chunk.js";
};